/**
 * @generated SignedSource<<9bd3fb1010537feb0fb293b54e2e7588>>
 * @relayHash 8212734baf53a5502154c09994d4ca16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3811d2948a1e274b1af50d05baee2fb40d87999bf3639cc2aca56a152dd69dd8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3811d2948a1e274b1af50d05baee2fb40d87999bf3639cc2aca56a152dd69dd8",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
